import styled from 'styled-components';
import {
  StyledHeaderImg,
  StyledSettingBox,
  StyledSettingHeader
} from '../SettingsModal.style';
import DonutImg from './donut-icon.png';
import LimitToggler from '../LimitToggler/LimitToggler';
import { CONFIG_WIDGETS_NAMES } from '../../hooks/useRaWidgetsConfig/useRaWidgetsConfig';

const StyledDonutConfig = styled(StyledSettingBox)``;

const WIDGET_NAME = CONFIG_WIDGETS_NAMES.DONUT_CHART;

const DonutConfig = ({ formWidgetsConfig }) => {
  const { limit, show_all_segments } =
    formWidgetsConfig.widgetsConfig[WIDGET_NAME];

  //TODO: should be remove after datadog testing
  const throwManualError = () => {
    const notObject = undefined;
    // eslint-disable-next-line no-unused-vars
    const moshe = notObject.tomer;
    // should throw a prop of undefined error
  };

  return (
    <StyledDonutConfig data-cy='styled-donut-config'>
      <StyledSettingHeader>
        Breakdown by FTE chart
        <StyledHeaderImg src={DonutImg} onDoubleClick={throwManualError} />
      </StyledSettingHeader>
      <LimitToggler
        limit={limit}
        updateLimit={limit =>
          formWidgetsConfig.updateWidgetLimit(WIDGET_NAME, limit)
        }
        showAllSegments={show_all_segments}
        toggleShowAllSegments={() =>
          formWidgetsConfig.toggleShowAllSegments(WIDGET_NAME)
        }
      />
    </StyledDonutConfig>
  );
};

export default DonutConfig;
